import { WizardItem } from '../../../types/wizard';

// Helper method to check if a wizard step containes options to select.
const currentStepHasOptions = (step?: WizardItem): boolean => {
  const optionsLength = step?.items.map((item) => item.items.length) || [];

  return !!optionsLength.filter(Boolean).length;
};

export { currentStepHasOptions };
